import { Box,  Typography, Tooltip, TextField, InputAdornment, FormControl, Select, MenuItem } from '@mui/material'
import React, { useState } from 'react'
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
import SearchIcon from '@mui/icons-material/Search';
import DataFilterInsight from './DataFilterInsight';
import InsightsDataTable from './InsightsDataTable';
const InsightsPage = () => {

    const [activeTab, setActiveTab] = useState('default');

    const [role, setRole] = useState('');
    const handleChangeUser = (event) => {
        setRole(event.target.value);
    };
    const roles = [
        { label: 'Customer support', },
        { label: 'Virtual assistant', },
        { label: 'Other', },
        { label: 'Project manager', },
        { label: 'Inspector', },
        { label: 'Field labor', },
        { label: 'Owner', },
        { label: 'Courier', },
        { label: 'Supervisor',},

    ];

    
    const [roleCommon, setCommon] = useState('');
    const handleCommon = (event) => {
        setCommon(event.target.value);
    };
    const rolesCommon = [
        { label: 'Most Common', },
        { label: 'Most Recent', },
        
    ];
    return (
        <>

            <Box sx={{ '& MuiBox-root': { padding: '0' } }}>
                <CustomTabPanel sx={{ '& MuiBox-root': { padding: '0' } }} value={activeTab} index="default">
                    <Box>
                        <Typography display="flex" alignItems="center" sx={{ m: '0 auto 4px', gap: '12px', fontSize: '16px', color: '#9095A1', fontWeight: '600', fontFamily: 'Manrope', textTransform: 'uppercase', lineHeight: '1' }}>
                            App/URL classification
                            <Tooltip title="This setting allows you to automatically assign members to a specific role when creating new projects. Choosing 'None' will disable automatic member assignments." arrow placement="top" alignContent="center">
                                <button className="tooltipBtn ms-2 border-0 bg-transparent p-0">
                                    <InfoOutlineIcon fontSize="small" />
                                </button>
                            </Tooltip>
                        </Typography>
                        <Typography sx={{ fontSize: '12px', color: '#1A1F36', fontWeight: '400', fontFamily: 'Manrope' }}>Organize applications and URLs according to the specific job roles in your company. You can customize the default ratings for each job title.</Typography>
                    </Box>
                    <Box display="flex" alignItems="center" justifyContent="space-between" sx={{ m: '16px auto 32px', p: '14px 12px', border: '1px solid #0076FE', borderRadius: '8px', backgroundColor: '#0076FE0A' }}>
                        <Typography display="flex" alignItems="center" sx={{ width: '80%', gap: '10px', fontSize: '15px', fontWeight: '500', color: '#0076FE', fontFamily: 'Manrope' }}><img class="img-fluid" alt="Budget Icon" src="./assets/images/app-activity/projects/icons/lock-icon.svg" />
                            We'll send you an email if any suspicious apps or URLs are detected.</Typography>


                    </Box>
                    <Box sx={{ m: '32px auto 24px', width: '100%' ,  paddingBottom: '24px', borderBottom: '1px solid #D0D4E4', display: {xl: 'flex' , lg: 'flex' , md: 'block' , sm: 'block' , xs: 'block'}, justifyContent: 'space-between', alignItems: 'center', }}>
                        <TextField sx={{width: '100%', marginBottom:'10px'}}
                            placeholder="Search App/URL"
                            size="small"
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon />
                                    </InputAdornment>
                                ),
                                sx: { borderRadius: '20px', background: '#fff', fontSize: '13px', width:{xl:'250px' , lg: '180px' , md: '100%' , sm: '100%' , xs: '100%'},   fontFamily: 'Manrope' },
                            }}
                        />
                        <Box display="flex" alignItems="center" sx={{ gap: '12px', marginBottom: '10px' }}>
                            <Box sx={{ width: {xl: '200px ' , lg: '170px' , md: '200px' , sm: '200px' , xs: '200px'}}}>
                                <FormControl fullWidth variant="outlined" size="small">
                                    <Select value={role} onChange={handleChangeUser} displayEmpty renderValue={(selected) => selected ? (selected) : (
                                        <Typography color="text.secondary" sx={{ fontSize: '14px', color: '#64748B', fontWeight: '400', fontFamily: 'Manrope', }}>
                                           Search All Job Type  
                                        </Typography>
                                    )}
                                        sx={{ backgroundColor: 'white', fontFamily: 'Manrope', fontSize: '14px', color: '#64748B', borderRadius: '100px' }}>
                                        {roles.map((option) => (
                                            <MenuItem key={option.label} value={option.label}>
                                                <Box>
                                                    <Typography variant="body1" sx={{ fontSize: '14px', color: '#1A1F36', fontWeight: '500', fontFamily: 'Manrope' }}>{option.label}</Typography>
                                                </Box>
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Box>
                                  <Box sx={{ width: {xl: '200px ' , lg: '150px' , md: '200px' , sm: '200px' , xs: '200px'}}}>
                                <FormControl fullWidth variant="outlined" size="small">
                                    <Select value={roleCommon} onChange={handleCommon} displayEmpty renderValue={(selected) => selected ? (selected) : (
                                        <Typography color="text.secondary" sx={{ fontSize: '14px', color: '#64748B', fontWeight: '400', fontFamily: 'Manrope', }}>
                                          Most Common
                                        </Typography>
                                    )}
                                        sx={{ backgroundColor: 'white', fontFamily: 'Manrope', fontSize: '14px', color: '#64748B', borderRadius: '100px' }}>
                                        {rolesCommon.map((option) => (
                                            <MenuItem key={option.label} value={option.label}>
                                                <Box>
                                                    <Typography variant="body1" sx={{ fontSize: '14px', color: '#1A1F36', fontWeight: '500', fontFamily: 'Manrope' }}>{option.label}</Typography>
                                                </Box>
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Box>
                          <DataFilterInsight/>
                        </Box>
                    </Box>
                  
                  <InsightsDataTable/>
                </CustomTabPanel>
            </Box>


        </>
    )
}
const CustomTabPanel = ({ value, index, children }) => {
    if (value !== index) return null;
    return <Box sx={{ padding: { xl: '0px 5px', lg: '0px 0', md: '0px 0', sm: '0px  0', sx: '0px 0' } }}>{children}</Box>;
};


export default InsightsPage
